import React, { useContext } from 'react';
import { mix, getSolidBackgroundShade } from 'utils/ui/colors';
import Box from 'components/Box';
import { CommentSizesContext } from '../Context';
import { jsx as _jsx } from "react/jsx-runtime";
export function CommentBubble(_ref) {
  var isHighlighted = _ref.isHighlighted,
    children = _ref.children;
  var size = useContext(CommentSizesContext);
  var isDefaultSize = size === 'DEFAULT';
  return /*#__PURE__*/_jsx(Box, {
    textColor: "text",
    background: isHighlighted ? function (theme) {
      return mix(getSolidBackgroundShade(theme))(theme.highlight, 0.75);
    } : 'shaded',
    px: isDefaultSize ? 'xs' : ['xs', 's'],
    py: isDefaultSize ? 'xxs' : ['xxs', 'xs'],
    fontSize: isDefaultSize ? 'xs' : ['xs', 'm'],
    breakpoints: "m",
    borderRadius: "small",
    overflow: "wrap",
    children: children
  });
}
export default CommentBubble;